import React from 'react';
import { motion } from 'framer-motion';
import { Star, Coffee, BookOpen } from 'lucide-react';
export function HeroSection() {
  return <section className="pt-24 pb-16 md:pt-32 md:pb-24 px-4 overflow-hidden" data-id="element-72">
      <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-73">
        {/* Text Content */}
        <motion.div initial={{
        opacity: 0,
        x: -30
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.6
      }} className="flex flex-col items-start" data-id="element-74">
          <div className="inline-flex items-center gap-2 bg-gold-500/20 text-gold-700 px-4 py-1.5 rounded-full text-sm font-bold mb-6 border border-gold-500/30" data-id="element-75">
            <BookOpen className="w-4 h-4" data-id="element-76" />
            GUÍA DIGITAL
          </div>

          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight mb-6 text-espresso-900" data-id="element-77">
            Aprende el arte de preparar{' '}
            <span className="text-gold-600 italic" data-id="element-78">café profesional</span> desde
            tu casa en menos de una semana.
          </h1>

          <p className="text-xl md:text-2xl text-espresso-800 mb-8 font-medium" data-id="element-79">
            Más de 500 recetas
          </p>

          <div className="flex items-center gap-2 mb-8 bg-cream-200 px-4 py-2 rounded-lg" data-id="element-80">
            <div className="flex text-gold-500" data-id="element-81">
              {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-current" data-id="element-82" />)}
            </div>
            <span className="font-bold text-espresso-900" data-id="element-83">4.8/5</span>
            <span className="text-espresso-700 text-sm" data-id="element-84">(+2,000 lectores)</span>
          </div>

          <a href="https://elartedelcafe.online/cart/add?id=57377971798341&quantity=1" className="w-full sm:w-auto bg-cta-600 hover:bg-cta-800 text-white text-lg md:text-xl font-bold py-4 px-8 rounded-xl shadow-lg hover:shadow-xl transition-all transform hover:-translate-y-1 text-center flex items-center justify-center gap-2" data-id="element-85">
            <span className="text-2xl" data-id="element-86">🟢</span> Agregar al carrito
          </a>

          <p className="mt-4 text-sm text-espresso-700 flex items-center gap-2" data-id="element-87">
            <span className="w-2 h-2 rounded-full bg-green-500 animate-pulse" data-id="element-88"></span>
            Acceso inmediato tras la compra
          </p>
        </motion.div>

        {/* Image Placeholder */}
        <motion.div initial={{
        opacity: 0,
        x: 30
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="relative" data-id="element-89">
          <div className="absolute inset-0 bg-gold-500/20 blur-3xl rounded-full transform -rotate-6 scale-105" data-id="element-90"></div>
          <div className="relative max-w-md mx-auto flex flex-col items-center text-center" data-id="element-91">
            <img src="https://cdn.magicpatterns.com/uploads/hYo6CP8csFeSZDfSppn3bL/20260312_1033_Image_Generation_remix_01kkh3yer1f6vbc3zvvk8zjamn.png" alt="El Arte del Café - Libro Digital" className="w-full rounded-2xl shadow-2xl object-cover" data-id="element-92" />
            <h3 className="font-serif text-3xl font-bold text-espresso-900 mt-6" data-id="element-93">
              El Arte del Café
            </h3>
          </div>
        </motion.div>
      </div>
    </section>;
}